import request from '@/request'
import handler from '@/utils/responseHandler'

export default {
  /**
   * 查询院校列表全量数据
   */
  '331322': () => request.ticket({
    url: '/gateway/gtgj/qp',
    sidFields: ['uid', 'pid'],
    data: {
      pid: 331322
    }
  }).then(handler.resBdData),
  /**
   * 院校数据模糊查询
   * university: 支持院校代码,字母简拼,名字。长度必须 >=2
   */
  '331324': (university) => request.ticket({
    url: '/gateway/gtgj/qp',
    sidFields: ['uid', 'pid'],
    data: {
      pid: 331324,
      university
    }
  }).then(handler.resBdData)
}


// WEBPACK FOOTER //
// ./src/api/school.js